import { Alert } from 'antd';
import SortImagesConf from './SortImagesConf/SortImagesConf';

export default function RealTimeActivityConf({ data, setConf }) {
  return data?.subType ? (
    <>
      {
        {
          sortImages: <SortImagesConf data={data} setConf={setConf} />,
        }[data.subType]
      }
    </>
  ) : (
    <Alert description="Select some activity to continue" />
  );
}
